<template>
  <div>
    <v-layout row wrap>
      <v-flex xs12>
        <v-btn v-if="adminActions" @click="$emit('newCalendarEventClicked')">
          {{ $t('Nuevo evento') }}
        </v-btn>
      </v-flex>
      <v-flex>
        <aru-search-entity
          v-if="configReady"
          :initial-constraint="initialConstraint"
          :search-config="searchConfig"
          :entity="entity"
          v-model="items"
          @loading="page = 1"
          @meta="setPagination"
        ></aru-search-entity>
      </v-flex>
    </v-layout>

    <v-list v-if="readyToList" :two-line="twoLine" :three-line="threeLine">
      <calendar-event-list-item
        :admin-actions="adminActions"
        v-for="item in items"
        @editEntity="editEntity"
        @entityDeleted="getEntities"
        :default-icon="defaultIcon"
        :key="item && item.id ? item.id : 'no-id'"
        :entity="item"
        :config="config"
        :level="level"
      ></calendar-event-list-item>
    </v-list>
    <div class="text-xs-center" v-if="showPagination">
      <v-pagination v-model="page" :length="pagination.last_page"></v-pagination>
    </div>
  </div>
</template>

<script>
// import apiCtrl from '@/services/api/abstract/abstract-api.js';
import AruListMixin from '@/mixins/list/AruListMixin.js';
import CalendarEventListItem from './CalendarEventListItem';
import AruSearchEntity from '@/components/commons/search/AruSearchEntity';
export default {
  mixins: [AruListMixin],
  components: {
    CalendarEventListItem,
    AruSearchEntity,
  },
  props: {
    adminActions: {
      type: Boolean,
      default: false,
    },
    initialFilters: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    const consultant_id =
      this.$store.state.user &&
      this.$store.state.user.consultant_profile &&
      this.$store.state.user.consultant_profile.id
        ? [this.$store.state.user.consultant_profile.id]
        : [];
    return {
      initialConstraint: {
        consultant_id: this.initialFilters ? [consultant_id] : [],
        status: this.initialFilters ? ['in_progress'] : [],
      },
    };
  },
  methods: {
    editEntity(data) {
      this.$emit('editEntity', data);
    },
  },
};
</script>

<style></style>
